import React, { Component } from "react";

export class SuccessPopup extends Component {
  render() {
    return (
      <div className="popup">
        <div className="popup-inner">
          <div data-qa="popup--success" className="popupNoConnection">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="icon">
                    <i className="fas fa-fw fa-check fa-2x" />
                  </div>
                  <h1 data-qa="popup__title">{this.props.title}</h1>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <p data-qa="popup__message">{this.props.message}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 text-center">
                  <div className="row">
                    <div className="col-4 ml-auto mr-auto">
                      <button
                        data-qa="popup__button"
                        className="btn btn-block btn-secondary"
                        onClick={this.props.shouldHide}
                        type="submit"
                      >
                        Ok
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SuccessPopup;
